import { api } from "./api";
import { customerSchema, Customer, subscriptionStatusSchema } from "./schemas/customer";

const customersUrl = `/customer`;
const maxSearchLength = 100;

export type GetCustomersParams = {
  subscriptionStatus?: string[];
  isRoot?: boolean;
  search?: string;
};

function buildCustomersQuery(params?: GetCustomersParams): string {
  if (params === undefined) return "";
  const searchParams = new URLSearchParams();
  const trimmed = params.search?.trim() ?? "";
  if (trimmed.length > 0) {
    searchParams.set("search", trimmed.slice(0, maxSearchLength));
  }
  const subscriptionStatus =
    params.subscriptionStatus?.filter(v => subscriptionStatusSchema.safeParse(v).success) ?? [];
  if (subscriptionStatus.length > 0) {
    searchParams.set("subscriptionStatus", subscriptionStatus.join(","));
  }
  if (params.isRoot === true || params.isRoot === false) {
    searchParams.set("isRoot", String(params.isRoot));
  }
  return searchParams.toString();
}

export async function getCustomers(params?: GetCustomersParams): Promise<Customer[]> {
  const query = buildCustomersQuery(params);
  const url = query.length > 0 ? `${customersUrl}?${query}` : customersUrl;
  const resp = await api.get(url);
  if (!resp.data) throw new Error(`Customers not returned`);
  return resp.data.map(customerSchema.parse);
}

export async function getCustomer(cxId: string): Promise<Customer> {
  const resp = await api.get(`${customersUrl}/${cxId}`);
  if (!resp.data) throw new Error(`Customer not returned`);
  return customerSchema.parse(resp.data);
}

export async function assignRoot(cxId: string): Promise<Customer> {
  const resp = await api.post(`${customersUrl}/${cxId}/root`);
  if (!resp.data) throw new Error(`Customer not returned`);
  return customerSchema.parse(resp.data);
}

export async function unassignRoot(cxId: string): Promise<Customer> {
  const resp = await api.delete(`${customersUrl}/${cxId}/root`);
  if (!resp.data) throw new Error(`Customer not returned`);
  return customerSchema.parse(resp.data);
}
